export { BonusTag } from './BonusTag'
export { DollarBills } from './DollarBills'
export { DocumentIcon } from './DocumentIcon'
export { Gift } from './Gift'
export { DasherPhone } from './DasherPhone'

export enum IconSizes {
  TINY = 12,
  SMALL = 16,
  MEDIUM = 24,
  LARGE = 32,
  X_LARGE = 48,
  XX_LARGE = 64,
  XXX_LARGE = 96,
  HUGE = 128,
}

export type IconProps = {
  size: IconSizes
  color: string
}
